import { Record } from "immutable";

const AdditionResultRecord = Record({
  id: null,
  surveyResultId: null,
  additionId: null,
  additionChoiceId: null
});

class AdditionResult extends AdditionResultRecord {}

export default AdditionResult;



// WEBPACK FOOTER //
// ./src/models/AdditionResult.js